import Quill from 'quill';

const Parchment = Quill.import('parchment');

const indentLevels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
const PIXELS_PER_LEVEL = 12;

export class IndentAttributor extends Parchment.Attributor.Style {
  add(node, value) {
    // When quill tries to set a value directly
    let newValue = value;

    // When we increase/decrease the indent manually
    if (value === '+1' || value === '-1') {
      const currentValue = this.value(node) ?? 0;

      newValue = currentValue + +value;
    }

    if (newValue <= 0) {
      return super.remove(node);
    }

    return super.add(node, `${newValue * PIXELS_PER_LEVEL}px`);
  }

  value(node) {
    return (
      parseFloat(super.value(node)?.replace('px', '')) / PIXELS_PER_LEVEL ||
      undefined
    ); // Don't return NaN
  }
}

const IndentStyle = new IndentAttributor('indent', 'margin-left', {
  scope: Parchment.Scope.BLOCK,
  whitelist: indentLevels.map((value) => `${value * PIXELS_PER_LEVEL}px`),
});

export default IndentStyle;
